import { useEffect, useState } from 'react';
import { CaretRightOutlined, PauseOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { AudioAutoPlayerContext } from '@/shared/Players/AudioAutoPlayer/AudioAutoPlayerContext';
import { useContext } from 'react';

export default function AudioPlayPauseButton({
  src,
  size,
  className,
  doPlay,
  noGUI,
}) {
  const audioAutoPlayerContext = useContext(AudioAutoPlayerContext);
  const [isPlaying, setIsPlaying] = useState(false);
  const play = async () => {
    try {
      await audioAutoPlayerContext.actions.play(src);
    } catch (error) {
      setIsPlaying(false);
    }
  };
  const pause = () => {
    audioAutoPlayerContext.actions.pause();
    setIsPlaying(false);
  };

  useEffect(() => {
    if (doPlay) {
      play();
    }
  }, [doPlay]);

  useEffect(() => {
    setIsPlaying(audioAutoPlayerContext.state.currentAudio === src);
  }, [audioAutoPlayerContext.state.currentAudio]);

  useEffect(() => {
    return () => {
      audioAutoPlayerContext.actions.reset();
    };
  }, []);

  return (
    <Button
      className={className}
      style={noGUI ? { display: 'none' } : {}}
      size={size}
      icon={isPlaying ? <PauseOutlined /> : <CaretRightOutlined />}
      onClick={isPlaying ? pause : play}
    />
  );
}
